import { useMutation } from "react-query";
import { deleteCamera } from "../../../../actions/CarrierAgreementMgmt/Security";

const useDeleteCamera = () => {
  return useMutation(deleteCamera);
};
export default useDeleteCamera;
